import React from 'react';

import './style.css';

const HomeVideo = () => (
  <div className="home-video">
    <iframe
      title="home-video"
      src="https://player.vimeo.com/video/330740865?autoplay=1&title=0&byline=0&portrait=0"
      frameBorder="0"
      allow="autoplay; fullscreen"
    />
  </div>
);

export default HomeVideo;



// WEBPACK FOOTER //
// ./src/pages/home/home-video/index.js